import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    isMobile: false,
    // 注册弹框状态
    registerDialogStatus: false,
  },
  getters,
  actions: {
    setMobile ({ commit }, value) {
      commit('SET_MOBILE', value)
    },
  },
  mutations: {
    SET_MOBILE (state, value) {
      state.isMobile = value
    },
    setRegisterDialogStatus(state, status) {
      state.registerDialogStatus = status
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js